import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, Transition } from "@headlessui/react";
import DeletePaymentProfile from "service/paymentServices/DeletePaymentProfile";
import PaymentProfileConfirmationModel from "components/ModalDialogs/PaymentProfileConfirmationModel";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";

const DeleteNonAutopayPaymentModal = ({
  modalState,
  setModalState,
  data,
  isUpdated,
  setIsUpdated,
}) => {
  const { t } = useTranslation(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [title, setTitle] = useState(false);
  const [message, setMessage] = useState(false);

  async function onSubmit() {
    if (data?.paymentProfileId) {
      //delete Payment Profile
      await DeletePaymentProfile(data.paymentProfileId)
        .then((response) => {
          console.log(response);
          if (response.ok) {
            setMessage(
              t(
                "CustomerManagePayment-manage-payment-card-delete-auto-pay-message1"
              )
            );
            setTitle(
              t(
                "CustomerManagePayment-manage-payment-card-delete-auto-pay-title1"
              )
            );
            setModalState(false);
            setOpenDialog(true);
          }
        })
        .catch((error) => {
          console.error(
            "Server refused to connect, please try again later.",
            error
          );
          setMessage(
            t(
              "CustomerManagePayment-manage-payment-card-delete-auto-pay-message2"
            )
          );
          setTitle(
            t(
              "CustomerManagePayment-manage-payment-card-delete-auto-pay-title2"
            )
          );
          setModalState(false);
          setOpenDialog(true);
        });
    }
  }
  return (
    <>
      <Transition appear show={modalState} as={Fragment}>
        <Dialog
          open={modalState}
          onClose={() => setModalState(false)}
          className="ui-dialogs fixed inset-0 z-50 overflow-y-auto"
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>
          {/* The backdrop, rendered as a fixed sibling to the panel container */}
          <DialogBackdrop />
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Panel className="ui-default-dialog">
              <Dialog.Title className="font-body text-xl font-bold text-left">
                {t(
                  "CustomerManagePayment-manage-payment-card-delete-auto-pay-payment-method"
                )}
              </Dialog.Title>
              <button
                className="ui-default-dialog-close"
                onClick={() => setModalState(false)}
              >
                <svg
                  className="ui-icon h-3.5 w-3.5"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-close"></use>
                </svg>
              </button>
              <hr />

              <Dialog.Description as="div">
                <p>
                  {t(
                    "CustomerManagePayment-manage-payment-card-delete-auto-pay-message"
                  )}
                </p>
                <div className="p-2 mt-4 border border-gray-light bg-ui-gray-lightest rounded-sm">
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-none lg:grid-flow-col gap-4">
                    <div>
                      <div className="text-xs text-theme-text-tertiary">
                        {t(
                          "CustomerManagePayment-manage-payment-card-delete-auto-pay-credit-card"
                        )}
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {data?.accountNumber}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-theme-text-tertiary">
                        {t(
                          "CustomerManagePayment-manage-payment-card-delete-auto-pay-cardholder-name"
                        )}
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {data?.ownerName}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-theme-text-tertiary">
                        {t(
                          "CustomerManagePayment-manage-payment-card-delete-auto-pay-expiration-date"
                        )}
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {data?.expDate}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-theme-text-tertiary">
                        {t(
                          "CustomerManagePayment-manage-payment-card-delete-auto-pay-card-type"
                        )}
                      </div>
                      <div className="text-sm font-semibold text-theme-text-secondary">
                        {data?.cardType}
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Description>
              <div className="block text-right mt-6">
                <button
                  className="ui-btn-secondary ui-btn-min-w mt-4"
                  onClick={() => setModalState(false)}
                >
                  {t(
                    "CustomerManagePayment-manage-payment-card-delete-auto-pay-no-keep"
                  )}
                  <span className="sr-only"> this payment method</span>
                </button>
                <button
                  className="ui-btn-primary ui-btn-min-w mt-4"
                  onClick={() => onSubmit()}
                >
                  {t(
                    "CustomerManagePayment-manage-payment-card-delete-auto-pay-yes-delete"
                  )}
                  <span className="sr-only"> this payment method</span>
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </Dialog>
      </Transition>
      <PaymentProfileConfirmationModel
        state={openDialog}
        setState={setOpenDialog}
        title={title}
        desc={message}
        isUpdated={isUpdated}
        setIsUpdated={setIsUpdated}
      />
    </>
  );
};

export default DeleteNonAutopayPaymentModal;
